import * as React from 'react';
import { cn } from '@/utils/cn';
import { MockMessageActions } from './MockMessageActions';

interface MockEchoBubbleProps {
  message: string;
  compact?: boolean;
  className?: string;
}

export const MockEchoBubble: React.FC<MockEchoBubbleProps> = ({ message, compact, className }) => (
  <div className={cn('mb-6 flex w-full flex-col items-start', className)}>
    <div
      className={cn(
        'relative w-fit',
        compact ? 'px-4 py-3' : 'px-6 py-5',
        'glass-bubble',
        'backdrop-blur-none md:backdrop-blur-md',
        'bg-gradient-50',
        'text-white',
        'rounded-24',
        'max-w-[636px]',
        compact
          ? 'font-sans text-14 font-medium leading-160 tracking-neg-2 xl:text-14'
          : 'font-sans text-14 font-medium leading-160 tracking-neg-2 xl:text-16'
      )}
    >
      <p className='whitespace-pre-wrap break-words'>{message}</p>
    </div>
    <MockMessageActions />
  </div>
);
